import CustomUpload from './src/upload.vue'

CustomUpload.install = function (Vue) {
    Vue.component(CustomUpload.name, CustomUpload)
}

export default CustomUpload;
